import React from "react";

import SelectGroups from "./select-groups";
const Filters = ({ children, show, cards, postType, postCategory, term }) => {
  return (
    <>
      {show && (
        <SelectGroups
          cards={cards}
          postType={postType}
          postCategory={postCategory}
          term={term}
        >
          {(filteredCards) => children(filteredCards)}
        </SelectGroups>
      )}

      {!show && children(cards)}
    </>
  );
};

export default Filters;
